import React, { useEffect, useState } from 'react';
import style from "../../addUser/addUser.module.css";
import styles from "./dashboard.module.css";
import Table, { tableCustomStyles } from '../../../components/CommonComponents/Table/Table';
import { useNavigate } from 'react-router-dom';
import { _axios } from '../../../utils/axios';
import { BASE_URL } from '../../../constants/Constants';
import { ErrorToast } from '../../../components/toastMessage';
import BoxComponent from '../../../components/CommonComponents/BoxComponent/BoxComponent';
import { PaginatorForRDT } from '../../../components/CommonComponents/Paginator/Paginator';
import { group } from 'console';
import { cookieUtils } from '../../../utils/cookieUtils';

const Dashboard = () => {
  const [totalList, setTotalList] = useState(0);
  const [totalActiveCount, setTotalActiveCount] = useState('--');
  const [totalInactiveCount, setTotalInactiveCount] = useState('--');
  const [adminList, setAdminList] = useState<Array<any>>([]);
  const [loginLogs, setLoginLogs] = useState<Array<any>>([]);
  const [loginLogsTotal, setLoginLogsTotal] = useState(0);
  const [loginLogsPage, setLoginLogsPage] = useState(1);
  const [loginLogsLimit, setLoginLogsLimit] = useState(10);
  const [activeUsersLast30Days, setActiveUsersLast30Days] = useState(0);
  const [totalSuperadmins, setTotalSuperadmins] = useState(0);
  const [totalActiveUsers, setTotalActiveUsers] = useState(0);
  const [activeApprovals, setActiveApprovals] = useState([]);
  const [totalApprovalList, setTotalApprovalList] = useState(0);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [startingIndex, setStartingIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const getActiveInactiveUsers = () => {
    _axios.get(`${BASE_URL}/api/admin/dashboard`, {
      params: {
        page: currentPage,
        limit: entriesPerPage,
      }
    })
      .then(function (response) {
        console.log("Response from get-login-logs:", response);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setTotalActiveCount(response.data.data.total_active_rows);
        setTotalInactiveCount(response.data.data.total_inactive_rows);
        setTotalList(response.data.data.total_rows);
      })
      .catch(function (error: any) {
        console.log(error);
      });
  }

  const getLoginLogs = () => {
    console.log(`Requesting login logs with page: ${loginLogsPage}, limit: ${loginLogsLimit}`);
    _axios.post(`${BASE_URL}/api/dashboard/get-login-logs`, {
      page: loginLogsPage,
      limit: loginLogsLimit
    })
      .then(function (response) {
        console.log("Response from get-login-logs:", response);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setLoginLogs(response.data.data);
        setLoginLogsTotal(response.data.total_rows); // Set total rows from backend response
      })
      .catch(function (error: any) {
        console.error("Error in getLoginLogs:", error);
      });
  }

  const getActiveUsersLast30Days = () => {
    _axios.get(`${BASE_URL}/api/dashboard/active-users-last-30-days`)
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setActiveUsersLast30Days(response.data.data);
      })
      .catch(function (error: any) {
        console.log(error);
      });
  }

  const getTotalSuperadmins = () => {
    _axios.get(`${BASE_URL}/api/dashboard/unique-superadmins`)
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setTotalSuperadmins(response.data.data);
      })
      .catch(function (error: any) {
        console.log(error);
      });
  }

  const getTotalActiveUsers = () => {
    _axios.get(`${BASE_URL}/api/dashboard/inactive-users`)
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setTotalActiveUsers(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getActiveApprovals = () => {
    _axios.get(`${BASE_URL}/api/dashboard/user-approval-list`)
      .then(function (response) {
        console.log("Response from:", response);

        if (response.data.success === 1 && response.data.data) {
          setActiveApprovals(response.data.data.activeApprovals);
          setTotalApprovalList(response.data.data.totalCount);
          console.log('Active approvals:', response.data.data.activeApprovals);
          console.log('Total count:', response.data.data.totalCount);
        } else {
          console.log("Unexpected response format");
          ErrorToast("Unexpected response format");
        }

        console.log('Full response data:', response.data);
      })
      .catch(function (error) {
        console.error("Error fetching active approvals:", error);
        // ErrorToast("Failed to fetch active approvals");
        console.log("Failed to fetch active approvals");
      });
  };

  useEffect(() => {
    getLoginLogs();
  }, [loginLogsPage, loginLogsLimit]);

  const handlePageChange = (page: number) => {
    console.log(`Changing page to: ${page}`);
    setLoginLogsPage(page);

  };

  const handlePerRowsChange = (newLimit: number) => {
    console.log(`Changing rows per page to: ${newLimit}`);
    setLoginLogsLimit(newLimit);
  };


  useEffect(() => {
    checkAuthorization();
  }, []);

  const checkAuthorization = () => {
    const userDetails = cookieUtils.getSecureCookie('userDetails');
    
    if (!userDetails || userDetails.role !== 'System Admin') {
      setIsLoading(false);
      ErrorToast("Access denied");
      navigate("/launch-page" , { replace: true });
      return;
    }
    
    setIsAuthorized(true);
    fetchDashboardData();
  };

  const fetchDashboardData = async () => {
    try {
      setIsLoading(true);
      await Promise.all([
        getActiveInactiveUsers(),
        getLoginLogs(),
        getActiveUsersLast30Days(),
        getTotalSuperadmins(),
        getTotalActiveUsers(),
        getActiveApprovals()
      ]);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      ErrorToast("Failed to load dashboard data");
    } finally {
      setIsLoading(false);
    }
  };

  // Effect for pagination changes
  useEffect(() => {
    if (isAuthorized) {
      getLoginLogs();
    }
  }, [loginLogsPage, loginLogsLimit, isAuthorized]);

  // ... all your data fetching functions remain the same

  if (isLoading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (!isAuthorized) {
    return null;
  }

  // useEffect(() => {
  //   getActiveInactiveUsers();
  //   // getLoginLogs();
  //   getActiveUsersLast30Days();
  //   getTotalSuperadmins();
  //   getTotalActiveUsers();
  //   getActiveApprovals();
  // }, [entriesPerPage, currentPage]);

  const dashboardData = [
    {
      color: '5px solid #E9B925',
      text: 'Total Active Users',
      count: activeUsersLast30Days
    },
    {
      color: '5px solid #E9B925',
      text: 'Total Active External Users',
      count: totalActiveUsers
    },
    {
      color: '5px solid #E9B925',
      text: 'Total Active Staff Users',
      count: totalSuperadmins
    },
    {
      color: '5px solid #E9B925',
      text: 'Users Pending Approval',
      count: totalApprovalList
    },
  ]

  const loginLogColumns = [
    {
      name: 'Sr. No.',
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (loginLogsPage - 1) * loginLogsLimit + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      width: "10%",
    },
    {
      name: 'User Name',
      selector: (log: any) => log.name,
      sortable: true,
      // width: "250px",
      width: "20%",
    },
    {
      name: 'Role',
      selector: (log: any) => log.role,
      sortable: true,
      // grow: 1,
      // width: "180px",
      width: "15%",
    },
    {
      name: 'Email',
      selector: (log: any) => log.email,
      sortable: true,
      // width: "300px",
      width: "20%",
    },
    {
      name: 'Mobile',
      selector: (log: any) => log.mobile,
      sortable: true,
      // grow: 0.5,
      // width: "150px",
      width: "15%",
    },
    {
      name: 'Login Date-Time',
      // width: "220px",
      selector: (log: any) => new Date(log.login_date_time).toLocaleString(),
      sortable: true,
      width: "20%",
    },
  ];



  return (
    <div className="px-5 py-5">
      <p className='text-2xl font-bold mt-4'>Dashboard</p>
      <div className={`${styles.customCss} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 py-4`}>
        {dashboardData.map((item, index) => {
          return (
            <div className="shadow-lg bg-white rounded-xl h-32" key={index}>
              <div className="flex">
                <div className="rounded-xl p-5 w-40 text-center content-center bg-white h-32" style={{ border: item.color }}>
                  <p className='font-bold text-gray text-5xl sm:text-5xl'>{item.count}</p>
                </div>
                <div className="rounded-xl p-5 w-60 text-center content-center bg-white h-32">
                  <p className='self-center text-center font-bold text-sm sm:text-base md:text-md lg:text-xl'>{item.text}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* <div className={`${styles.customCss} flex py-6 justify-center items-center`}>
        {dashboardData.map((item, index) => {
          return (
            <div className='shadow-lg bg-white rounded-xl flex text-center w-full mx-2 my-3 md:w-1/2 lg:w-1/3 xl:w-1/4' key={index}>
              <div className='rounded-xl min-h-28 min-w-28 flex justify-center items-center' style={{ border: item.color }}>
                <p className='font-bold text-gray text-5xl sm:text-5xl'>{item.count}</p>
              </div>
              <div className='p-3 sm:p-3 flex items-center text-center'>
                <p className='self-center text-center font-bold text-sm sm:text-base md:text-md lg:text-xl'>{item.text}</p>
              </div>
            </div>
          )
        })}
      </div> */}

      <div className='p-15 mt-3 mb-15'>
        <p className='text-2xl font-bold mb-4 mt-7'>Login History</p>
        <BoxComponent>
          <Table
            columns={loginLogColumns}
            data={loginLogs}
            isPagination={true}
            paginationTotalRows={loginLogsTotal || 0}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            customStyles={tableCustomStyles}
            paginationComponent={PaginatorForRDT}
          />
        </BoxComponent>
      </div>
    </div>
  )
}

export default Dashboard;
